<template><!-- svgo-optimised -->
<svg class="icon icon__loading" viewBox="0 0 70 70"
     xmlns="http://www.w3.org/2000/svg">
  <path
    d="M35 11.972c-13.17 0-23.846 10.676-23.846 23.846S21.83 59.664 35 59.664s23.846-10.676 23.846-23.846S48.17 11.972 35 11.972ZM5 35.818c0-16.568 13.431-30 30-30 16.569 0 30 13.432 30 30 0 16.569-13.431 30-30 30-16.569 0-30-13.431-30-30Z"
    fill-rule="evenodd" clip-rule="evenodd"/>
  <path
    d="M34.93 11.958c-13.139 0-23.79 10.651-23.79 23.79a3.07 3.07 0 1 1-6.14 0c0-16.53 13.4-29.93 29.93-29.93a3.07 3.07 0 1 1 0 6.14Z"
    fill="#ff5c1d" fill-rule="evenodd" clip-rule="evenodd"/>
</svg>
</template>